import { fetchApi } from '@/shared/api/fetchApi';

export interface ClientVerifyData {
  passport_document_number: string;
  passport_issued_at: string;
  passport_valid_till: string;
  driver_license_document_number: string;
  driver_license_issued_at: string;
  driver_license_valid_till: string;
}

interface VerificationResponse {
  result: 'ok';
}

interface DocumentsArchiveResponse {
  url: string;
}

export const clientVerificationApi = {
  getDocumentsArchiveUrl: async (clientId: string): Promise<DocumentsArchiveResponse> => {
    return fetchApi<DocumentsArchiveResponse>(`/api/v1/documents/${clientId}/archive_url`);
  },

  acceptVerification: async (clientId: string, data: ClientVerifyData): Promise<VerificationResponse> => {
    return fetchApi<VerificationResponse>(`/api/v1/documents/${clientId}/accept`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  declineVerification: async (clientId: string): Promise<VerificationResponse> => {
    return fetchApi<VerificationResponse>(`/api/v1/documents/${clientId}/decline`, {
      method: 'POST',
    });
  },

  // New simplified methods for archive verification
  acceptArchiveVerification: async (clientId: string): Promise<VerificationResponse> => {
    return fetchApi<VerificationResponse>(`/api/v1/documents/${clientId}/accept`, {
      method: 'POST',
    });
  },

  declineArchiveVerification: async (clientId: string): Promise<VerificationResponse> => {
    return fetchApi<VerificationResponse>(`/api/v1/documents/${clientId}/decline`, {
      method: 'POST',
    });
  },
};
